<template>
  <div class="home-wrap">
    <div class="padding-12-15 padding-b-20">
      <div class="title-text">资金明细</div>
      <div class="account-info">
        <div class="account-left">
          <div>账户余额</div>
          <div class="balance">{{balance}}</div>
          <div>锁定金额<span class="freeze-amount">{{freeze_amount}}</span>元</div>
        </div>
        <div class="withdraw-btn" @click="withdraw">提现</div>
      </div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15">
      <div class="alipay-account-div">收款账户<span class="alipay-account">{{alipayAccount}}（{{alipayRealName}}）</span></div>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15">
      <div class="title-text">充值金额</div>
      <el-row :gutter="9" class="padding-t-8 padding-b-20">
        <el-col :span="8" v-for="(item,index) of rechargeAmountList" :key="index">
          <div class="color-222" :class="( moneyActiveIndex == index)?'money-item active':'money-item'" @click="chooseMoney(item,index)">{{item}}元</div>
        </el-col>
      </el-row>
      <div class="title-text">其他金额</div>
      <el-row class="padding-t-8">
        <el-col :span="17">
          <el-input type="text" v-model="customMoney" ref="customMoney" class="money-input" placeholder="请输入充值金额"></el-input>
        </el-col>
        <el-col :span="7">
          <div class="confirm-btn" @click="subCustomMoney()">确定</div>
        </el-col>
      </el-row>
    </div>
    <div class="gray"></div>
    <div class="padding-12-15 padding-b-20">
      <div class="title-text">
        <img class="alipay-icon" src="../../../../assets/img/h5/alipay.png" alt="">支付宝支付
      </div>
      <div class="title-text">扫码支付</div>
      <div class="qrcode-wrap" v-if="qrcode_status === 1">
        <div class="pay-qrcode-img">
          <img class="bg-img" src="@/assets/img/promotion/pay_bg.png">
          <div class="qrcode-img">
            <img :src="qrcode_url">
          </div>
        </div>
      </div>
      <div class="question-wrap margin-b-14">
        <div class="color-ff4 padding-b-8">已充值，未到账？</div>
          <div class="order-input">
            <span class="color-666">输入交易订单</span>
            <img @click="isShowExample = true" src="../../../../assets/img/promotion/btn_doubt.png" alt="">
            <el-input v-model="alipayTrade" placeholder="支付宝转账记录上的交易订单号"></el-input>
            <div class="order-btn" @click="showTip">提交</div>
          </div>
          <van-overlay :show="isShowExample" @click="isShowExample = false" >
            <div class="example-wrap">
              <img src="../../../../assets/img/promotion/account/example.png" />
            </div>
          </van-overlay>
          <div class="order-tip">
            <div>1.扫码支付完成后，点击余额右边的“刷新”按钮，可获取充值金额；</div>
            <div>2.若刷新后，余额并未增加，请您手动认领；</div>
            <div>3.若认领失败，请联系客服为您手动确认。</div>
          </div>
        </div>
      </div>
      <AccountTip ref="AccountTip"></AccountTip>
      <Withdraw ref="Withdraw" :info="withdrawInfo" @refreshList="getList(true)"/></Withdraw>
    </div>
  </div>
</template>

<script>
  import AccountTip from '@/views/h5/promotion/account/modal/Tip.vue'
  import Withdraw from '@/views/h5/promotion/account/modal/Withdraw.vue'
  import { accountIndex,accountInfo,changeAlipayQrcode,getAlipayQuery } from '@/api/account'
  export default {
    name: 'PromotionAccount',
    components:{
      AccountTip,
      Withdraw,
    },
    data: function () {
      return {
        balance:'',
        freeze_amount:'',
        rechargeAmountList: [],
        alipayRealName:'',
        alipayAccount:'',

        moneyActiveIndex: -1,
        selectMoney: 0,
        customMoney:'',
        alipayTrade: '',
        qrcode_status: 0,
        qrcode_url: '',
        qrcode_msg: '',
        isShowExample: false,
        withdrawInfo:{
          max_withdraw_amount:''
        }
      }
    },
    created() {
      this.accountIndex()
    },
    methods: {
      accountIndex(){
        accountIndex().then(response => {
          this.balance = response.data.balance
          this.freeze_amount = response.data.freeze_amount
          this.rechargeAmountList = response.data.rechargeAmountList.value
          this.alipayRealName = response.data.alipayRealName.value
          this.alipayAccount = response.data.alipayAccount.value
          this.qrcode_status = response.data.payqrcode.code
          this.qrcode_url = response.data.payqrcode.url
          this.withdrawInfo.max_withdraw_amount = response.data.max_withdraw_amount
          if(response.data.payqrcode.code === 0) {
            console.log(response.data.payqrcode.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      showTip: function () {
        var orderInfo = new Object
        var type = 1
        if (this.alipayTrade === '') {
          orderInfo.title = '提示'
          orderInfo.errorDesc = '请填支付宝交易订单号'
          orderInfo.createTime = ''
          orderInfo.amount = 0
          orderInfo.tradeNo = ''
          this.$refs.AccountTip.init(4, orderInfo)
        } else {
          getAlipayQuery({'trade_no':this.alipayTrade}).then(response => {
            if(response.data.code === 200){
              orderInfo.title = '充值成功'
              orderInfo.errorDesc = response.msg
              orderInfo.createTime = response.date
              orderInfo.amount = response.money
              orderInfo.tradeNo = this.alipayTrade
              type = 1
            }else{
              orderInfo.title = '提示'
              orderInfo.errorDesc = response.msg
              orderInfo.createTime = ''
              orderInfo.amount = 0
              orderInfo.tradeNo = this.alipayTrade
              type = 3;
            }
            this.$refs.AccountTip.init(type, orderInfo)
          }).catch(error => {
            console.log('error',error)
            return;
            orderInfo.title = '提示'
            orderInfo.errorDesc = ''
            orderInfo.createTime = ''
            orderInfo.amount = 0
            orderInfo.tradeNo = this.alipayTrade
            this.$refs.AccountTip.init(type, orderInfo)
          })
        }
      },
      //用户提现
      withdraw: function () {
        this.$refs.Withdraw.init()
      },
      chooseMoney: function (item, index) {
        this.moneyActiveIndex = index
        this.selectMoney = item
        changeAlipayQrcode({'money':this.selectMoney}).then(response => {
          this.qrcode_status = response.data.code
          this.qrcode_url = response.data.url
          if(response.data.code === 0) {
            console.log(response.data.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      subCustomMoney: function () {
        console.log('money',this.$refs.customMoney.value)
        let reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^[0-9]\.[0-9]([0-9])?$)/;
        if (!reg.test(this.$refs.customMoney.value)) {
          this.$toast.fail('金额错误');
          return false;
        }
        changeAlipayQrcode({'money':this.$refs.customMoney.value}).then(response => {
          this.qrcode_status = response.data.code
          this.qrcode_url = response.data.url
          if(response.data.code === 0) {
            console.log(response.data.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .home-wrap{
    font-family: Alibaba-PuHuiTi-R;
    .account-info{
      background-image: url(../../../../assets/img/h5/chongzhi_bg.png);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: 50% 50%;
      width: 100%;
      height: 120px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      color: #FFFFFF;
      text-align: center;
      padding: 15px;
      margin-top: 8px;
      .account-left{
        text-align: left;
        font-size: 14px;
        .balance{
          font-size: 26px;
          padding-bottom: 15px;
        }
        .freeze-amount{
          font-size: 16px;
          padding-left: 5px;
        }
      }
      .withdraw-btn{
        width: 80px;
        height: 30px;
        line-height: 30px;
        border-radius: 15px;
        background: #FFFFFF;
        color: #FF8622;
      }
    }
    .alipay-account-div{
      font-size: 17px;
      color: #222222;
      font-family: Alibaba-PuHuiTi-M;
      .alipay-account{
        padding-left: 10px;
        font-family: Alibaba-PuHuiTi-R;
        color: #999999;
        font-size: 16px;
      }
    }
    .el-row{
      .el-col{
        padding-bottom: 9px;
        .money-item{
          height:40px;
          border: 1px solid #E8E8E8;
          border-radius: 2px;
          line-height: 40px;
          text-align: center;
          font-family: Alibaba-PuHuiTi-M;
          font-size: 17px;
        }
        .active{
          border: 1px solid #FF8622;
          color: #FF8622;
        }
        .confirm-btn{
          background: #FF8622;
          color: #FFFFFF;
          height: 44px;
          line-height: 44px;
          text-align: center;
          border-radius: 2px;
        }
      }
    }
    .alipay-icon{
      width: 22px;
      margin-right: 5px;
    }
    .qrcode-wrap{
      background: #FFFFFF;
      box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
      width:45%;
      margin:0 auto 20px auto;
      .qrcode-header{
        height: 40px;
        text-align: center;
        img{
          height: 18px;
          margin-top: 11px;
        }
      }
      .qrcode-content{
        background: #00AAEE;
        height: 160px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
          width: 80px;
        }
        .qrcode-tip{
          color: #FFFFFF;
          padding-top: 15px;
          font-size: 12px;
        }
      }
      .pay-qrcode-img{
        position: relative;
      }
      .pay-qrcode-img .bg-img{
        width: 100%;
      }
      .pay-qrcode-img .qrcode-img{
        text-align: center;
        background: #F5F5FA;
        width: 75px;
        position: absolute;
        top: 97px;
        left: 50%;
        transform: translateX(-50%);
        -ms-transform: translateX(-50%);	/* IE 9 */
        -moz-transform: translateX(-50%);	/* Firefox */
        -webkit-transform: translateX(-50%);/* Safari 和 Chrome */
        -o-transform: translateX(-50%); 	/* Opera */
      }
      .pay-qrcode-img .qrcode-img img{
        width: 100%;
      }
    }
    .question-wrap{
      background: #FAFAFA;
      padding:10px;
      height: auto;
      .order-input{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        span{
          white-space: nowrap;
        }
        img{
          width: 22px;
        }
        .order-btn{
          background: #FF4F76;
          color: #FFFFFF;
          white-space: nowrap;
          height: 30px;
          line-height: 30px;
          min-width: 50px;
          margin-top:0;
          text-align: center;
        }
      }
      .example-wrap{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        img{
          width: 85%;
        }
      }
      .order-tip{
        padding: 10px 0 0px 0;
        color: #999999;
        font-size: 12px;
        div{
          padding: 2px 0;
        }
      }
    }
  }
  /deep/.money-input .el-input__inner{
    height: 44px;
    line-height: 44px;
    color: #CCCCCC;
    border: none;
    background-color: #F7F7F7;
    border-radius: 2px;
  }
  /deep/.order-input .el-input__inner{
    height: 30px;
    line-height: 30px;
    border-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/promotion/account/Index.vue